// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/types/account.proto" (package "mlmbox.types", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Asset_Amount } from "./asset.ts";
import { Relationship } from "./relationship.ts";
import { GoogleAuthenticator } from "./google_authenticator.ts";
/**
 * @generated from protobuf message mlmbox.types.Account
 */
export interface Account {
    /**
     * @generated from protobuf field: mlmbox.types.Account.Info info = 1;
     */
    info?: Account_Info;
    /**
     * @generated from protobuf field: mlmbox.types.GoogleAuthenticator google_authenticator = 2;
     */
    googleAuthenticator?: GoogleAuthenticator;
    /**
     * @generated from protobuf field: repeated mlmbox.types.TreeAccount tree_accounts = 3;
     */
    treeAccounts: TreeAccount[];
    /**
     * @generated from protobuf field: string locale = 5;
     */
    locale: string; // language identifier (en-US, ...)
    /**
     * @generated from protobuf field: bool is_admin = 6;
     */
    isAdmin: boolean;
    /**
     * @generated from protobuf field: bool referral_change_access = 7;
     */
    referralChangeAccess: boolean;
}
/**
 * @generated from protobuf message mlmbox.types.Account.Id
 */
export interface Account_Id {
    /**
     * @generated from protobuf oneof: unique_field
     */
    uniqueField: {
        oneofKind: "accountId";
        /**
         * @generated from protobuf field: uint32 account_id = 1;
         */
        accountId: number;
    } | {
        oneofKind: "accountLogin";
        /**
         * @generated from protobuf field: string account_login = 2;
         */
        accountLogin: string;
    } | {
        oneofKind: "refLinkId";
        /**
         * @generated from protobuf field: string ref_link_id = 3;
         */
        refLinkId: string;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message mlmbox.types.Account.RefLink
 */
export interface Account_RefLink {
    /**
     * @generated from protobuf field: uint32 account_id = 1;
     */
    accountId: number;
    /**
     * @generated from protobuf field: uint32 source_id = 2;
     */
    sourceId: number;
}
/**
 * @generated from protobuf message mlmbox.types.Account.Username
 */
export interface Account_Username {
    /**
     * @generated from protobuf field: uint32 id = 1;
     */
    id: number;
    /**
     * @generated from protobuf field: string login = 2;
     */
    login: string;
    /**
     * @generated from protobuf field: string ref_link_id = 3;
     */
    refLinkId: string;
}
/**
 * @generated from protobuf message mlmbox.types.Account.Profile
 */
export interface Account_Profile {
    /**
     * @generated from protobuf field: string first_name = 1;
     */
    firstName: string;
    /**
     * @generated from protobuf field: string last_name = 2;
     */
    lastName: string;
    /**
     * @generated from protobuf field: mlmbox.types.Account.Profile.Telegram telegram = 3;
     */
    telegram?: Account_Profile_Telegram;
    /**
     * @generated from protobuf field: mlmbox.types.Account.Profile.Ava ava = 4;
     */
    ava?: Account_Profile_Ava;
}
/**
 * @generated from protobuf message mlmbox.types.Account.Profile.Ava
 */
export interface Account_Profile_Ava {
    /**
     * @generated from protobuf field: uint32 collection_id = 1;
     */
    collectionId: number;
    /**
     * @generated from protobuf field: uint32 entity_id = 2;
     */
    entityId: number;
}
/**
 * @generated from protobuf message mlmbox.types.Account.Profile.Ava.List
 */
export interface Account_Profile_Ava_List {
    /**
     * @generated from protobuf field: repeated mlmbox.types.Account.Profile.Ava items = 1;
     */
    items: Account_Profile_Ava[];
}
/**
 * @generated from protobuf message mlmbox.types.Account.Profile.Ava.File
 */
export interface Account_Profile_Ava_File {
    /**
     * @generated from protobuf field: uint32 collection_id = 1;
     */
    collectionId: number;
    /**
     * @generated from protobuf field: uint32 entity_id = 2;
     */
    entityId: number;
    /**
     * @generated from protobuf field: string value = 3;
     */
    value: string;
}
/**
 * @generated from protobuf message mlmbox.types.Account.Profile.Ava.File.List
 */
export interface Account_Profile_Ava_File_List {
    /**
     * @generated from protobuf field: repeated mlmbox.types.Account.Profile.Ava.File items = 1;
     */
    items: Account_Profile_Ava_File[];
}
/**
 * @generated from protobuf message mlmbox.types.Account.Profile.Telegram
 */
export interface Account_Profile_Telegram {
    /**
     * @generated from protobuf field: uint64 id = 1;
     */
    id: bigint;
    /**
     * @generated from protobuf field: string username = 2;
     */
    username: string;
}
/**
 * @generated from protobuf message mlmbox.types.Account.Statistics
 */
export interface Account_Statistics {
    /**
     * @generated from protobuf field: uint32 partners_quantity = 1;
     */
    partnersQuantity: number;
    /**
     * @generated from protobuf field: uint32 team_quantity = 2;
     */
    teamQuantity: number;
    /**
     * @generated from protobuf field: uint32 marketing_partners_quantity = 3;
     */
    marketingPartnersQuantity: number;
    /**
     * @generated from protobuf field: uint32 marketing_team_quantity = 4;
     */
    marketingTeamQuantity: number;
}
/**
 * @generated from protobuf message mlmbox.types.Account.Info
 */
export interface Account_Info {
    /**
     * @generated from protobuf field: mlmbox.types.Account.Profile profile = 1;
     */
    profile?: Account_Profile;
    /**
     * @generated from protobuf field: mlmbox.types.Account.Username account = 2;
     */
    account?: Account_Username;
    /**
     * @generated from protobuf field: mlmbox.types.Account.Username referral = 3;
     */
    referral?: Account_Username;
    /**
     * @generated from protobuf field: mlmbox.types.Relationship relationship = 4;
     */
    relationship?: Relationship;
    /**
     * @generated from protobuf field: uint32 registration_at = 5;
     */
    registrationAt: number;
    /**
     * @generated from protobuf field: uint32 marketing_started_at = 6;
     */
    marketingStartedAt: number;
    /**
     * @generated from protobuf field: int32 tree_ids_bit_mask = 7;
     */
    treeIdsBitMask: number;
    /**
     * @generated from protobuf field: uint32 referral_branch = 8;
     */
    referralBranch: number;
    /**
     * @generated from protobuf field: mlmbox.types.Account.Statistics statistics = 9;
     */
    statistics?: Account_Statistics;
    /**
     * @generated from protobuf field: repeated uint32 channels = 10;
     */
    channels: number[]; // List of channel IDs in which the user participates
}
/**
 * @generated from protobuf message mlmbox.types.Account.Info.List
 */
export interface Account_Info_List {
    /**
     * @generated from protobuf field: repeated mlmbox.types.Account.Info items = 1;
     */
    items: Account_Info[];
}
/**
 * @generated from protobuf message mlmbox.types.Tree
 */
export interface Tree {
    /**
     * @generated from protobuf field: uint32 id = 1;
     */
    id: number;
    /**
     * @generated from protobuf field: string title = 2;
     */
    title: string;
    /**
     * @generated from protobuf field: uint32 group_id = 3;
     */
    groupId: number;
    /**
     * @generated from protobuf field: uint32 positions_quantity = 4;
     */
    positionsQuantity: number;
    /**
     * @generated from protobuf field: uint32 default_position_width = 5;
     */
    defaultPositionWidth: number;
    /**
     * @generated from protobuf field: mlmbox.types.Asset.Amount amount = 6;
     */
    amount?: Asset_Amount;
    /**
     * @generated from protobuf field: bool booking_enabled = 7;
     */
    bookingEnabled: boolean;
    /**
     * @generated from protobuf field: mlmbox.types.Tree.Mode tree_mode_id = 8;
     */
    treeModeId: Tree_Mode;
    /**
     * @generated from protobuf field: repeated uint32 require_tree_ids = 9;
     */
    requireTreeIds: number[];
}
/**
 * @generated from protobuf message mlmbox.types.Tree.Group
 */
export interface Tree_Group {
    /**
     * @generated from protobuf field: uint32 id = 1;
     */
    id: number;
    /**
     * @generated from protobuf field: string title = 2;
     */
    title: string;
}
/**
 * @generated from protobuf enum mlmbox.types.Tree.Mode
 */
export enum Tree_Mode {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: MATRIX = 1;
     */
    MATRIX = 1,
    /**
     * @generated from protobuf enum value: BINARY = 2;
     */
    BINARY = 2
}
/**
 * @generated from protobuf message mlmbox.types.TreeAccount
 */
export interface TreeAccount {
    /**
     * @generated from protobuf field: uint32 tree_id = 1;
     */
    treeId: number;
    /**
     * @generated from protobuf field: uint32 quantity = 2;
     */
    quantity: number;
    /**
     * @generated from protobuf field: uint32 activated_quantity = 3;
     */
    activatedQuantity: number;
    /**
     * @generated from protobuf field: uint32 activated_capacity = 4;
     */
    activatedCapacity: number;
    /**
     * @generated from protobuf field: string pool_value = 5;
     */
    poolValue: string;
    /**
     * @generated from protobuf field: uint32 booking_quantity = 6;
     */
    bookingQuantity: number;
    /**
     * @generated from protobuf field: repeated mlmbox.types.TreeAccount.Entity entities = 7;
     */
    entities: TreeAccount_Entity[];
}
/**
 * @generated from protobuf message mlmbox.types.TreeAccount.Id
 */
export interface TreeAccount_Id {
    /**
     * @generated from protobuf field: uint32 tree_id = 1;
     */
    treeId: number;
    /**
     * @generated from protobuf field: uint32 account_id = 2;
     */
    accountId: number;
}
/**
 * @generated from protobuf message mlmbox.types.TreeAccount.List
 */
export interface TreeAccount_List {
    /**
     * @generated from protobuf field: repeated mlmbox.types.TreeAccount items = 1;
     */
    items: TreeAccount[];
}
/**
 * @generated from protobuf message mlmbox.types.TreeAccount.Entity
 */
export interface TreeAccount_Entity {
    /**
     * @generated from protobuf field: uint32 position_id = 1;
     */
    positionId: number; // Position identifier
    /**
     * @generated from protobuf field: uint32 tree_chain_id = 2;
     */
    treeChainId: number; // Main chain (tree_chain_id==0) or in a separate substructure (tree_chain_id>0)
    /**
     * @generated from protobuf field: uint32 tree_entity_id = 3;
     */
    treeEntityId: number; // Sequence number in the "tree"
    /**
     * @generated from protobuf field: uint32 tree_account_entity_id = 4;
     */
    treeAccountEntityId: number; // Sequence number in the ("tree" + "account") combination
    /**
     * @generated from protobuf field: uint32 filled_2w2l_bit_mask = 5 [json_name = "filled2w2lBitMask"];
     */
    filled2W2LBitMask: number;
    /**
     * @generated from protobuf field: bool filled = 6;
     */
    filled: boolean; // Is the position filled?
    /**
     * @generated from protobuf field: bool view_access = 7;
     */
    viewAccess: boolean; // Access to the view
}
/**
 * @generated from protobuf message mlmbox.types.TreeAccount.Set
 */
export interface TreeAccount_Set {
    /**
     * @generated from protobuf field: uint32 tree_id = 1;
     */
    treeId: number;
    /**
     * @generated from protobuf field: uint32 quantity = 2;
     */
    quantity: number;
    /**
     * @generated from protobuf field: uint32 activated_quantity = 3;
     */
    activatedQuantity: number;
    /**
     * @generated from protobuf field: uint32 activated_capacity = 4;
     */
    activatedCapacity: number;
    /**
     * @generated from protobuf field: string pool_value = 5;
     */
    poolValue: string;
    /**
     * @generated from protobuf field: uint32 booking_quantity = 6;
     */
    bookingQuantity: number;
    /**
     * @generated from protobuf field: mlmbox.types.TreeAccount.Entity entity = 7;
     */
    entity?: TreeAccount_Entity;
}
/**
 * @generated from protobuf message mlmbox.types.PositionView
 */
export interface PositionView {
}
/**
 * @generated from protobuf message mlmbox.types.PositionView.Id
 */
export interface PositionView_Id {
    /**
     * @generated from protobuf field: uint32 view_position_id = 1;
     */
    viewPositionId: number;
}
/**
 * @generated from protobuf message mlmbox.types.PositionView.Team
 */
export interface PositionView_Team {
    /**
     * @generated from protobuf field: uint32 view_level = 1;
     */
    viewLevel: number;
    /**
     * @generated from protobuf oneof: query
     */
    query: {
        oneofKind: "viewPositionId";
        /**
         * @generated from protobuf field: uint32 view_position_id = 2;
         */
        viewPositionId: number;
    } | {
        oneofKind: "treeAccountId";
        /**
         * @generated from protobuf field: mlmbox.types.TreeAccount.Id tree_account_id = 3;
         */
        treeAccountId: TreeAccount_Id;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message mlmbox.types.Matrix
 */
export interface Matrix {
}
/**
 * @generated from protobuf message mlmbox.types.Matrix.Reinvest
 */
export interface Matrix_Reinvest {
}
/**
 * @generated from protobuf message mlmbox.types.Matrix.Reinvest.Request
 */
export interface Matrix_Reinvest_Request {
    /**
     * @generated from protobuf field: uint32 position_id = 1;
     */
    positionId: number;
    /**
     * @generated from protobuf field: bool reinvest_enabled = 2;
     */
    reinvestEnabled: boolean;
}
/**
 * @generated from protobuf message mlmbox.types.Matrix.Position
 */
export interface Matrix_Position {
    /**
     * @generated from protobuf field: uint32 position_id = 1;
     */
    positionId: number; // Position identifier
    /**
     * @generated from protobuf field: uint32 position_ref_id = 2;
     */
    positionRefId: number; // Superior position identifier
    /**
     * @generated from protobuf field: uint32 position_ref_branch = 3;
     */
    positionRefBranch: number; // Upstream branch identifier
    /**
     * @generated from protobuf field: uint32 position_width = 4;
     */
    positionWidth: number; // Number of available branches
    /**
     * @generated from protobuf field: uint32 account_id = 5;
     */
    accountId: number; // Account identifier
    /**
     * @generated from protobuf field: uint32 tree_chain_id = 6;
     */
    treeChainId: number; // Main chain (tree_chain_id==0) or in a separate substructure (tree_chain_id>0)
    /**
     * @generated from protobuf field: uint32 tree_entity_id = 7;
     */
    treeEntityId: number; // Sequence number in the "tree"
    /**
     * @generated from protobuf field: uint32 tree_account_entity_id = 8;
     */
    treeAccountEntityId: number; // Sequence number in the ("tree" + "account") combination
    /**
     * @generated from protobuf field: uint32 partners_quantity = 9;
     */
    partnersQuantity: number;
    /**
     * @generated from protobuf field: uint32 team_quantity = 10;
     */
    teamQuantity: number;
    /**
     * @generated from protobuf field: string pool_value = 11;
     */
    poolValue: string;
    /**
     * @generated from protobuf field: bool reinvest_enabled = 12;
     */
    reinvestEnabled: boolean;
    /**
     * @generated from protobuf field: bool filled = 13;
     */
    filled: boolean;
}
/**
 * @generated from protobuf message mlmbox.types.Matrix.View
 */
export interface Matrix_View {
    /**
     * @generated from protobuf field: uint32 tree_id = 1;
     */
    treeId: number;
    /**
     * @generated from protobuf field: uint32 self_position_id = 2;
     */
    selfPositionId: number;
    /**
     * @generated from protobuf field: uint32 self_tree_ids_bit_mask = 3;
     */
    selfTreeIdsBitMask: number;
    /**
     * @generated from protobuf field: uint32 view_position_id = 4;
     */
    viewPositionId: number;
    /**
     * @generated from protobuf field: uint32 view_tree_ids_bit_mask = 5;
     */
    viewTreeIdsBitMask: number;
    /**
     * @generated from protobuf field: repeated mlmbox.types.Matrix.Position positions = 6;
     */
    positions: Matrix_Position[];
    /**
     * @generated from protobuf field: repeated mlmbox.types.Account.Info accounts = 7;
     */
    accounts: Account_Info[];
    /**
     * @generated from protobuf field: repeated mlmbox.types.TreeAccount.Entity view_tree_account_entities = 8;
     */
    viewTreeAccountEntities: TreeAccount_Entity[];
}
/**
 * @generated from protobuf message mlmbox.types.Matrix.Info
 */
export interface Matrix_Info {
    /**
     * @generated from protobuf field: repeated mlmbox.types.TreeAccount items = 1;
     */
    items: TreeAccount[];
}
/**
 * @generated from protobuf message mlmbox.types.Binary
 */
export interface Binary {
}
/**
 * @generated from protobuf message mlmbox.types.Binary.BranchSelectStrategy
 */
export interface Binary_BranchSelectStrategy {
    /**
     * @generated from protobuf field: mlmbox.types.Binary.BranchSelectStrategy.Id branch_select_strategy_id = 1;
     */
    branchSelectStrategyId: Binary_BranchSelectStrategy_Id;
}
/**
 * @generated from protobuf message mlmbox.types.Binary.BranchSelectStrategy.Request
 */
export interface Binary_BranchSelectStrategy_Request {
    /**
     * @generated from protobuf field: uint32 position_id = 1;
     */
    positionId: number;
    /**
     * @generated from protobuf field: mlmbox.types.Binary.BranchSelectStrategy.Id branch_select_strategy_id = 2;
     */
    branchSelectStrategyId: Binary_BranchSelectStrategy_Id;
}
/**
 * @generated from protobuf enum mlmbox.types.Binary.BranchSelectStrategy.Id
 */
export enum Binary_BranchSelectStrategy_Id {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: LEFT = 1;
     */
    LEFT = 1,
    /**
     * @generated from protobuf enum value: RIGHT = 2;
     */
    RIGHT = 2,
    /**
     * @generated from protobuf enum value: EVENLY = 3;
     */
    EVENLY = 3
}
/**
 * @generated from protobuf message mlmbox.types.Binary.Config
 */
export interface Binary_Config {
    /**
     * @generated from protobuf field: string bonus_binary_percent = 1;
     */
    bonusBinaryPercent: string;
    /**
     * @generated from protobuf field: string bonus_matching_percent = 2;
     */
    bonusMatchingPercent: string;
    /**
     * @generated from protobuf field: uint32 tree_entities_quantity = 3;
     */
    treeEntitiesQuantity: number;
}
/**
 * @generated from protobuf message mlmbox.types.Binary.Position
 */
export interface Binary_Position {
    /**
     * @generated from protobuf field: uint32 position_id = 1;
     */
    positionId: number; // Position identifier
    /**
     * @generated from protobuf field: uint32 position_ref_id = 2;
     */
    positionRefId: number; // Superior position identifier
    /**
     * @generated from protobuf field: uint32 position_ref_branch = 3;
     */
    positionRefBranch: number; // Upstream branch identifier
    /**
     * @generated from protobuf field: uint32 position_width = 4;
     */
    positionWidth: number; // Number of available branches
    /**
     * @generated from protobuf field: uint32 account_id = 5;
     */
    accountId: number; // Account identifier
    /**
     * @generated from protobuf field: uint32 tree_chain_id = 6;
     */
    treeChainId: number; // Main chain (tree_chain_id==0) or in a separate substructure (tree_chain_id>0)
    /**
     * @generated from protobuf field: uint32 tree_entity_id = 7;
     */
    treeEntityId: number; // Sequence number in the "tree"
    /**
     * @generated from protobuf field: uint32 tree_account_entity_id = 8;
     */
    treeAccountEntityId: number; // Sequence number in the ("tree" + "account") combination
    /**
     * @generated from protobuf field: uint32 partners_quantity = 9;
     */
    partnersQuantity: number;
    /**
     * @generated from protobuf field: uint32 team_quantity = 10;
     */
    teamQuantity: number;
    /**
     * @generated from protobuf field: string earned_value = 11;
     */
    earnedValue: string;
    /**
     * @generated from protobuf field: mlmbox.types.Binary.BranchSelectStrategy.Id branch_select_strategy = 12;
     */
    branchSelectStrategy: Binary_BranchSelectStrategy_Id;
    /**
     * @generated from protobuf field: mlmbox.types.Binary.Position.Branch branch_left = 13;
     */
    branchLeft?: Binary_Position_Branch;
    /**
     * @generated from protobuf field: mlmbox.types.Binary.Position.Branch branch_right = 14;
     */
    branchRight?: Binary_Position_Branch;
}
/**
 * @generated from protobuf message mlmbox.types.Binary.Position.Branch
 */
export interface Binary_Position_Branch {
    /**
     * @generated from protobuf field: uint32 team_quantity = 1;
     */
    teamQuantity: number;
    /**
     * @generated from protobuf field: string balance_value = 2;
     */
    balanceValue: string;
    /**
     * @generated from protobuf field: string turnover_value = 3;
     */
    turnoverValue: string;
}
/**
 * @generated from protobuf message mlmbox.types.Binary.View
 */
export interface Binary_View {
    /**
     * @generated from protobuf field: uint32 tree_id = 1;
     */
    treeId: number;
    /**
     * @generated from protobuf field: mlmbox.types.Binary.Config config = 2;
     */
    config?: Binary_Config;
    /**
     * @generated from protobuf field: uint32 self_position_id = 3;
     */
    selfPositionId: number;
    /**
     * @generated from protobuf field: uint32 self_tree_ids_bit_mask = 4;
     */
    selfTreeIdsBitMask: number;
    /**
     * @generated from protobuf field: uint32 view_position_id = 5;
     */
    viewPositionId: number;
    /**
     * @generated from protobuf field: uint32 view_tree_ids_bit_mask = 6;
     */
    viewTreeIdsBitMask: number;
    /**
     * @generated from protobuf field: repeated mlmbox.types.Binary.Position positions = 7;
     */
    positions: Binary_Position[];
    /**
     * @generated from protobuf field: repeated mlmbox.types.Account.Info accounts = 8;
     */
    accounts: Account_Info[];
    /**
     * @generated from protobuf field: repeated mlmbox.types.TreeAccount.Entity view_tree_account_entities = 9;
     */
    viewTreeAccountEntities: TreeAccount_Entity[];
}
/**
 * @generated from protobuf message mlmbox.types.Binary.Info
 */
export interface Binary_Info {
    /**
     * @generated from protobuf field: repeated mlmbox.types.Binary.Info.Item items = 1;
     */
    items: Binary_Info_Item[];
}
/**
 * @generated from protobuf message mlmbox.types.Binary.Info.Item
 */
export interface Binary_Info_Item {
    /**
     * @generated from protobuf field: mlmbox.types.TreeAccount tree_account = 1;
     */
    treeAccount?: TreeAccount;
    /**
     * @generated from protobuf field: mlmbox.types.Binary.Config config = 2;
     */
    config?: Binary_Config;
}
// @generated message type with reflection information, may provide speed optimized methods
class Account$Type extends MessageType<Account> {
    constructor() {
        super("mlmbox.types.Account", [
            { no: 1, name: "info", kind: "message", T: () => Account_Info },
            { no: 2, name: "google_authenticator", kind: "message", T: () => GoogleAuthenticator },
            { no: 3, name: "tree_accounts", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => TreeAccount },
            { no: 5, name: "locale", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "is_admin", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "referral_change_access", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<Account>): Account {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.treeAccounts = [];
        message.locale = "";
        message.isAdmin = false;
        message.referralChangeAccess = false;
        if (value !== undefined)
            reflectionMergePartial<Account>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Account): Account {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* mlmbox.types.Account.Info info */ 1:
                    message.info = Account_Info.internalBinaryRead(reader, reader.uint32(), options, message.info);
                    break;
                case /* mlmbox.types.GoogleAuthenticator google_authenticator */ 2:
                    message.googleAuthenticator = GoogleAuthenticator.internalBinaryRead(reader, reader.uint32(), options, message.googleAuthenticator);
                    break;
                case /* repeated mlmbox.types.TreeAccount tree_accounts */ 3:
                    message.treeAccounts.push(TreeAccount.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string locale */ 5:
                    message.locale = reader.string();
                    break;
                case /* bool is_admin */ 6:
                    message.isAdmin = reader.bool();
                    break;
                case /* bool referral_change_access */ 7:
                    message.referralChangeAccess = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Account, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* mlmbox.types.Account.Info info = 1; */
        if (message.info)
            Account_Info.internalBinaryWrite(message.info, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* mlmbox.types.GoogleAuthenticator google_authenticator = 2; */
        if (message.googleAuthenticator)
            GoogleAuthenticator.internalBinaryWrite(message.googleAuthenticator, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated mlmbox.types.TreeAccount tree_accounts = 3; */
        for (let i = 0; i < message.treeAccounts.length; i++)
            TreeAccount.internalBinaryWrite(message.treeAccounts[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string locale = 5; */
        if (message.locale !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.locale);
        /* bool is_admin = 6; */
        if (message.isAdmin !== false)
            writer.tag(6, WireType.Varint).bool(message.isAdmin);
        /* bool referral_change_access = 7; */
        if (message.referralChangeAccess !== false)
            writer.tag(7, WireType.Varint).bool(message.referralChangeAccess);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Account
 */
export const Account = new Account$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Account_Id$Type extends MessageType<Account_Id> {
    constructor() {
        super("mlmbox.types.Account.Id", [
            { no: 1, name: "account_id", kind: "scalar", oneof: "uniqueField", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "account_login", kind: "scalar", oneof: "uniqueField", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "ref_link_id", kind: "scalar", oneof: "uniqueField", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Account_Id>): Account_Id {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.uniqueField = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<Account_Id>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Account_Id): Account_Id {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 account_id */ 1:
                    message.uniqueField = {
                        oneofKind: "accountId",
                        accountId: reader.uint32()
                    };
                    break;
                case /* string account_login */ 2:
                    message.uniqueField = {
                        oneofKind: "accountLogin",
                        accountLogin: reader.string()
                    };
                    break;
                case /* string ref_link_id */ 3:
                    message.uniqueField = {
                        oneofKind: "refLinkId",
                        refLinkId: reader.string()
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Account_Id, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 account_id = 1; */
        if (message.uniqueField.oneofKind === "accountId")
            writer.tag(1, WireType.Varint).uint32(message.uniqueField.accountId);
        /* string account_login = 2; */
        if (message.uniqueField.oneofKind === "accountLogin")
            writer.tag(2, WireType.LengthDelimited).string(message.uniqueField.accountLogin);
        /* string ref_link_id = 3; */
        if (message.uniqueField.oneofKind === "refLinkId")
            writer.tag(3, WireType.LengthDelimited).string(message.uniqueField.refLinkId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Account.Id
 */
export const Account_Id = new Account_Id$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Account_RefLink$Type extends MessageType<Account_RefLink> {
    constructor() {
        super("mlmbox.types.Account.RefLink", [
            { no: 1, name: "account_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "source_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<Account_RefLink>): Account_RefLink {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = 0;
        message.sourceId = 0;
        if (value !== undefined)
            reflectionMergePartial<Account_RefLink>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Account_RefLink): Account_RefLink {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 account_id */ 1:
                    message.accountId = reader.uint32();
                    break;
                case /* uint32 source_id */ 2:
                    message.sourceId = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Account_RefLink, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 account_id = 1; */
        if (message.accountId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.accountId);
        /* uint32 source_id = 2; */
        if (message.sourceId !== 0)
            writer.tag(2, WireType.Varint).uint32(message.sourceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Account.RefLink
 */
export const Account_RefLink = new Account_RefLink$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Account_Username$Type extends MessageType<Account_Username> {
    constructor() {
        super("mlmbox.types.Account.Username", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "login", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "ref_link_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Account_Username>): Account_Username {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        message.login = "";
        message.refLinkId = "";
        if (value !== undefined)
            reflectionMergePartial<Account_Username>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Account_Username): Account_Username {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                case /* string login */ 2:
                    message.login = reader.string();
                    break;
                case /* string ref_link_id */ 3:
                    message.refLinkId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Account_Username, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        /* string login = 2; */
        if (message.login !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.login);
        /* string ref_link_id = 3; */
        if (message.refLinkId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.refLinkId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Account.Username
 */
export const Account_Username = new Account_Username$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Account_Profile$Type extends MessageType<Account_Profile> {
    constructor() {
        super("mlmbox.types.Account.Profile", [
            { no: 1, name: "first_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "last_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "telegram", kind: "message", T: () => Account_Profile_Telegram },
            { no: 4, name: "ava", kind: "message", T: () => Account_Profile_Ava }
        ]);
    }
    create(value?: PartialMessage<Account_Profile>): Account_Profile {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.firstName = "";
        message.lastName = "";
        if (value !== undefined)
            reflectionMergePartial<Account_Profile>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Account_Profile): Account_Profile {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string first_name */ 1:
                    message.firstName = reader.string();
                    break;
                case /* string last_name */ 2:
                    message.lastName = reader.string();
                    break;
                case /* mlmbox.types.Account.Profile.Telegram telegram */ 3:
                    message.telegram = Account_Profile_Telegram.internalBinaryRead(reader, reader.uint32(), options, message.telegram);
                    break;
                case /* mlmbox.types.Account.Profile.Ava ava */ 4:
                    message.ava = Account_Profile_Ava.internalBinaryRead(reader, reader.uint32(), options, message.ava);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Account_Profile, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string first_name = 1; */
        if (message.firstName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.firstName);
        /* string last_name = 2; */
        if (message.lastName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.lastName);
        /* mlmbox.types.Account.Profile.Telegram telegram = 3; */
        if (message.telegram)
            Account_Profile_Telegram.internalBinaryWrite(message.telegram, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* mlmbox.types.Account.Profile.Ava ava = 4; */
        if (message.ava)
            Account_Profile_Ava.internalBinaryWrite(message.ava, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Account.Profile
 */
export const Account_Profile = new Account_Profile$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Account_Profile_Ava$Type extends MessageType<Account_Profile_Ava> {
    constructor() {
        super("mlmbox.types.Account.Profile.Ava", [
            { no: 1, name: "collection_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "entity_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<Account_Profile_Ava>): Account_Profile_Ava {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.collectionId = 0;
        message.entityId = 0;
        if (value !== undefined)
            reflectionMergePartial<Account_Profile_Ava>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Account_Profile_Ava): Account_Profile_Ava {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 collection_id */ 1:
                    message.collectionId = reader.uint32();
                    break;
                case /* uint32 entity_id */ 2:
                    message.entityId = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Account_Profile_Ava, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 collection_id = 1; */
        if (message.collectionId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.collectionId);
        /* uint32 entity_id = 2; */
        if (message.entityId !== 0)
            writer.tag(2, WireType.Varint).uint32(message.entityId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Account.Profile.Ava
 */
export const Account_Profile_Ava = new Account_Profile_Ava$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Account_Profile_Ava_List$Type extends MessageType<Account_Profile_Ava_List> {
    constructor() {
        super("mlmbox.types.Account.Profile.Ava.List", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Account_Profile_Ava }
        ]);
    }
    create(value?: PartialMessage<Account_Profile_Ava_List>): Account_Profile_Ava_List {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial<Account_Profile_Ava_List>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Account_Profile_Ava_List): Account_Profile_Ava_List {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated mlmbox.types.Account.Profile.Ava items */ 1:
                    message.items.push(Account_Profile_Ava.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Account_Profile_Ava_List, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated mlmbox.types.Account.Profile.Ava items = 1; */
        for (let i = 0; i < message.items.length; i++)
            Account_Profile_Ava.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Account.Profile.Ava.List
 */
export const Account_Profile_Ava_List = new Account_Profile_Ava_List$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Account_Profile_Ava_File$Type extends MessageType<Account_Profile_Ava_File> {
    constructor() {
        super("mlmbox.types.Account.Profile.Ava.File", [
            { no: 1, name: "collection_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "entity_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Account_Profile_Ava_File>): Account_Profile_Ava_File {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.collectionId = 0;
        message.entityId = 0;
        message.value = "";
        if (value !== undefined)
            reflectionMergePartial<Account_Profile_Ava_File>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Account_Profile_Ava_File): Account_Profile_Ava_File {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 collection_id */ 1:
                    message.collectionId = reader.uint32();
                    break;
                case /* uint32 entity_id */ 2:
                    message.entityId = reader.uint32();
                    break;
                case /* string value */ 3:
                    message.value = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Account_Profile_Ava_File, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 collection_id = 1; */
        if (message.collectionId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.collectionId);
        /* uint32 entity_id = 2; */
        if (message.entityId !== 0)
            writer.tag(2, WireType.Varint).uint32(message.entityId);
        /* string value = 3; */
        if (message.value !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Account.Profile.Ava.File
 */
export const Account_Profile_Ava_File = new Account_Profile_Ava_File$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Account_Profile_Ava_File_List$Type extends MessageType<Account_Profile_Ava_File_List> {
    constructor() {
        super("mlmbox.types.Account.Profile.Ava.File.List", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Account_Profile_Ava_File }
        ]);
    }
    create(value?: PartialMessage<Account_Profile_Ava_File_List>): Account_Profile_Ava_File_List {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial<Account_Profile_Ava_File_List>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Account_Profile_Ava_File_List): Account_Profile_Ava_File_List {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated mlmbox.types.Account.Profile.Ava.File items */ 1:
                    message.items.push(Account_Profile_Ava_File.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Account_Profile_Ava_File_List, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated mlmbox.types.Account.Profile.Ava.File items = 1; */
        for (let i = 0; i < message.items.length; i++)
            Account_Profile_Ava_File.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Account.Profile.Ava.File.List
 */
export const Account_Profile_Ava_File_List = new Account_Profile_Ava_File_List$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Account_Profile_Telegram$Type extends MessageType<Account_Profile_Telegram> {
    constructor() {
        super("mlmbox.types.Account.Profile.Telegram", [
            { no: 1, name: "id", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Account_Profile_Telegram>): Account_Profile_Telegram {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0n;
        message.username = "";
        if (value !== undefined)
            reflectionMergePartial<Account_Profile_Telegram>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Account_Profile_Telegram): Account_Profile_Telegram {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint64 id */ 1:
                    message.id = reader.uint64().toBigInt();
                    break;
                case /* string username */ 2:
                    message.username = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Account_Profile_Telegram, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).uint64(message.id);
        /* string username = 2; */
        if (message.username !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.username);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Account.Profile.Telegram
 */
export const Account_Profile_Telegram = new Account_Profile_Telegram$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Account_Statistics$Type extends MessageType<Account_Statistics> {
    constructor() {
        super("mlmbox.types.Account.Statistics", [
            { no: 1, name: "partners_quantity", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "team_quantity", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "marketing_partners_quantity", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "marketing_team_quantity", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<Account_Statistics>): Account_Statistics {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.partnersQuantity = 0;
        message.teamQuantity = 0;
        message.marketingPartnersQuantity = 0;
        message.marketingTeamQuantity = 0;
        if (value !== undefined)
            reflectionMergePartial<Account_Statistics>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Account_Statistics): Account_Statistics {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 partners_quantity */ 1:
                    message.partnersQuantity = reader.uint32();
                    break;
                case /* uint32 team_quantity */ 2:
                    message.teamQuantity = reader.uint32();
                    break;
                case /* uint32 marketing_partners_quantity */ 3:
                    message.marketingPartnersQuantity = reader.uint32();
                    break;
                case /* uint32 marketing_team_quantity */ 4:
                    message.marketingTeamQuantity = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Account_Statistics, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 partners_quantity = 1; */
        if (message.partnersQuantity !== 0)
            writer.tag(1, WireType.Varint).uint32(message.partnersQuantity);
        /* uint32 team_quantity = 2; */
        if (message.teamQuantity !== 0)
            writer.tag(2, WireType.Varint).uint32(message.teamQuantity);
        /* uint32 marketing_partners_quantity = 3; */
        if (message.marketingPartnersQuantity !== 0)
            writer.tag(3, WireType.Varint).uint32(message.marketingPartnersQuantity);
        /* uint32 marketing_team_quantity = 4; */
        if (message.marketingTeamQuantity !== 0)
            writer.tag(4, WireType.Varint).uint32(message.marketingTeamQuantity);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Account.Statistics
 */
export const Account_Statistics = new Account_Statistics$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Account_Info$Type extends MessageType<Account_Info> {
    constructor() {
        super("mlmbox.types.Account.Info", [
            { no: 1, name: "profile", kind: "message", T: () => Account_Profile },
            { no: 2, name: "account", kind: "message", T: () => Account_Username },
            { no: 3, name: "referral", kind: "message", T: () => Account_Username },
            { no: 4, name: "relationship", kind: "message", T: () => Relationship },
            { no: 5, name: "registration_at", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 6, name: "marketing_started_at", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 7, name: "tree_ids_bit_mask", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "referral_branch", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 9, name: "statistics", kind: "message", T: () => Account_Statistics },
            { no: 10, name: "channels", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<Account_Info>): Account_Info {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.registrationAt = 0;
        message.marketingStartedAt = 0;
        message.treeIdsBitMask = 0;
        message.referralBranch = 0;
        message.channels = [];
        if (value !== undefined)
            reflectionMergePartial<Account_Info>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Account_Info): Account_Info {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* mlmbox.types.Account.Profile profile */ 1:
                    message.profile = Account_Profile.internalBinaryRead(reader, reader.uint32(), options, message.profile);
                    break;
                case /* mlmbox.types.Account.Username account */ 2:
                    message.account = Account_Username.internalBinaryRead(reader, reader.uint32(), options, message.account);
                    break;
                case /* mlmbox.types.Account.Username referral */ 3:
                    message.referral = Account_Username.internalBinaryRead(reader, reader.uint32(), options, message.referral);
                    break;
                case /* mlmbox.types.Relationship relationship */ 4:
                    message.relationship = Relationship.internalBinaryRead(reader, reader.uint32(), options, message.relationship);
                    break;
                case /* uint32 registration_at */ 5:
                    message.registrationAt = reader.uint32();
                    break;
                case /* uint32 marketing_started_at */ 6:
                    message.marketingStartedAt = reader.uint32();
                    break;
                case /* int32 tree_ids_bit_mask */ 7:
                    message.treeIdsBitMask = reader.int32();
                    break;
                case /* uint32 referral_branch */ 8:
                    message.referralBranch = reader.uint32();
                    break;
                case /* mlmbox.types.Account.Statistics statistics */ 9:
                    message.statistics = Account_Statistics.internalBinaryRead(reader, reader.uint32(), options, message.statistics);
                    break;
                case /* repeated uint32 channels */ 10:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.channels.push(reader.uint32());
                    else
                        message.channels.push(reader.uint32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Account_Info, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* mlmbox.types.Account.Profile profile = 1; */
        if (message.profile)
            Account_Profile.internalBinaryWrite(message.profile, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* mlmbox.types.Account.Username account = 2; */
        if (message.account)
            Account_Username.internalBinaryWrite(message.account, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* mlmbox.types.Account.Username referral = 3; */
        if (message.referral)
            Account_Username.internalBinaryWrite(message.referral, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* mlmbox.types.Relationship relationship = 4; */
        if (message.relationship)
            Relationship.internalBinaryWrite(message.relationship, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* uint32 registration_at = 5; */
        if (message.registrationAt !== 0)
            writer.tag(5, WireType.Varint).uint32(message.registrationAt);
        /* uint32 marketing_started_at = 6; */
        if (message.marketingStartedAt !== 0)
            writer.tag(6, WireType.Varint).uint32(message.marketingStartedAt);
        /* int32 tree_ids_bit_mask = 7; */
        if (message.treeIdsBitMask !== 0)
            writer.tag(7, WireType.Varint).int32(message.treeIdsBitMask);
        /* uint32 referral_branch = 8; */
        if (message.referralBranch !== 0)
            writer.tag(8, WireType.Varint).uint32(message.referralBranch);
        /* mlmbox.types.Account.Statistics statistics = 9; */
        if (message.statistics)
            Account_Statistics.internalBinaryWrite(message.statistics, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated uint32 channels = 10; */
        if (message.channels.length) {
            writer.tag(10, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.channels.length; i++)
                writer.uint32(message.channels[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Account.Info
 */
export const Account_Info = new Account_Info$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Account_Info_List$Type extends MessageType<Account_Info_List> {
    constructor() {
        super("mlmbox.types.Account.Info.List", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Account_Info }
        ]);
    }
    create(value?: PartialMessage<Account_Info_List>): Account_Info_List {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial<Account_Info_List>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Account_Info_List): Account_Info_List {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated mlmbox.types.Account.Info items */ 1:
                    message.items.push(Account_Info.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Account_Info_List, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated mlmbox.types.Account.Info items = 1; */
        for (let i = 0; i < message.items.length; i++)
            Account_Info.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Account.Info.List
 */
export const Account_Info_List = new Account_Info_List$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Tree$Type extends MessageType<Tree> {
    constructor() {
        super("mlmbox.types.Tree", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "group_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "positions_quantity", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "default_position_width", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 6, name: "amount", kind: "message", T: () => Asset_Amount },
            { no: 7, name: "booking_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "tree_mode_id", kind: "enum", T: () => ["mlmbox.types.Tree.Mode", Tree_Mode] },
            { no: 9, name: "require_tree_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<Tree>): Tree {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        message.title = "";
        message.groupId = 0;
        message.positionsQuantity = 0;
        message.defaultPositionWidth = 0;
        message.bookingEnabled = false;
        message.treeModeId = 0;
        message.requireTreeIds = [];
        if (value !== undefined)
            reflectionMergePartial<Tree>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Tree): Tree {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                case /* string title */ 2:
                    message.title = reader.string();
                    break;
                case /* uint32 group_id */ 3:
                    message.groupId = reader.uint32();
                    break;
                case /* uint32 positions_quantity */ 4:
                    message.positionsQuantity = reader.uint32();
                    break;
                case /* uint32 default_position_width */ 5:
                    message.defaultPositionWidth = reader.uint32();
                    break;
                case /* mlmbox.types.Asset.Amount amount */ 6:
                    message.amount = Asset_Amount.internalBinaryRead(reader, reader.uint32(), options, message.amount);
                    break;
                case /* bool booking_enabled */ 7:
                    message.bookingEnabled = reader.bool();
                    break;
                case /* mlmbox.types.Tree.Mode tree_mode_id */ 8:
                    message.treeModeId = reader.int32();
                    break;
                case /* repeated uint32 require_tree_ids */ 9:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.requireTreeIds.push(reader.uint32());
                    else
                        message.requireTreeIds.push(reader.uint32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Tree, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        /* string title = 2; */
        if (message.title !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.title);
        /* uint32 group_id = 3; */
        if (message.groupId !== 0)
            writer.tag(3, WireType.Varint).uint32(message.groupId);
        /* uint32 positions_quantity = 4; */
        if (message.positionsQuantity !== 0)
            writer.tag(4, WireType.Varint).uint32(message.positionsQuantity);
        /* uint32 default_position_width = 5; */
        if (message.defaultPositionWidth !== 0)
            writer.tag(5, WireType.Varint).uint32(message.defaultPositionWidth);
        /* mlmbox.types.Asset.Amount amount = 6; */
        if (message.amount)
            Asset_Amount.internalBinaryWrite(message.amount, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* bool booking_enabled = 7; */
        if (message.bookingEnabled !== false)
            writer.tag(7, WireType.Varint).bool(message.bookingEnabled);
        /* mlmbox.types.Tree.Mode tree_mode_id = 8; */
        if (message.treeModeId !== 0)
            writer.tag(8, WireType.Varint).int32(message.treeModeId);
        /* repeated uint32 require_tree_ids = 9; */
        if (message.requireTreeIds.length) {
            writer.tag(9, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.requireTreeIds.length; i++)
                writer.uint32(message.requireTreeIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Tree
 */
export const Tree = new Tree$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Tree_Group$Type extends MessageType<Tree_Group> {
    constructor() {
        super("mlmbox.types.Tree.Group", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Tree_Group>): Tree_Group {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        message.title = "";
        if (value !== undefined)
            reflectionMergePartial<Tree_Group>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Tree_Group): Tree_Group {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                case /* string title */ 2:
                    message.title = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Tree_Group, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        /* string title = 2; */
        if (message.title !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.title);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Tree.Group
 */
export const Tree_Group = new Tree_Group$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TreeAccount$Type extends MessageType<TreeAccount> {
    constructor() {
        super("mlmbox.types.TreeAccount", [
            { no: 1, name: "tree_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "quantity", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "activated_quantity", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "activated_capacity", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "pool_value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "booking_quantity", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 7, name: "entities", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => TreeAccount_Entity }
        ]);
    }
    create(value?: PartialMessage<TreeAccount>): TreeAccount {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.treeId = 0;
        message.quantity = 0;
        message.activatedQuantity = 0;
        message.activatedCapacity = 0;
        message.poolValue = "";
        message.bookingQuantity = 0;
        message.entities = [];
        if (value !== undefined)
            reflectionMergePartial<TreeAccount>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TreeAccount): TreeAccount {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 tree_id */ 1:
                    message.treeId = reader.uint32();
                    break;
                case /* uint32 quantity */ 2:
                    message.quantity = reader.uint32();
                    break;
                case /* uint32 activated_quantity */ 3:
                    message.activatedQuantity = reader.uint32();
                    break;
                case /* uint32 activated_capacity */ 4:
                    message.activatedCapacity = reader.uint32();
                    break;
                case /* string pool_value */ 5:
                    message.poolValue = reader.string();
                    break;
                case /* uint32 booking_quantity */ 6:
                    message.bookingQuantity = reader.uint32();
                    break;
                case /* repeated mlmbox.types.TreeAccount.Entity entities */ 7:
                    message.entities.push(TreeAccount_Entity.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TreeAccount, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 tree_id = 1; */
        if (message.treeId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.treeId);
        /* uint32 quantity = 2; */
        if (message.quantity !== 0)
            writer.tag(2, WireType.Varint).uint32(message.quantity);
        /* uint32 activated_quantity = 3; */
        if (message.activatedQuantity !== 0)
            writer.tag(3, WireType.Varint).uint32(message.activatedQuantity);
        /* uint32 activated_capacity = 4; */
        if (message.activatedCapacity !== 0)
            writer.tag(4, WireType.Varint).uint32(message.activatedCapacity);
        /* string pool_value = 5; */
        if (message.poolValue !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.poolValue);
        /* uint32 booking_quantity = 6; */
        if (message.bookingQuantity !== 0)
            writer.tag(6, WireType.Varint).uint32(message.bookingQuantity);
        /* repeated mlmbox.types.TreeAccount.Entity entities = 7; */
        for (let i = 0; i < message.entities.length; i++)
            TreeAccount_Entity.internalBinaryWrite(message.entities[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.TreeAccount
 */
export const TreeAccount = new TreeAccount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TreeAccount_Id$Type extends MessageType<TreeAccount_Id> {
    constructor() {
        super("mlmbox.types.TreeAccount.Id", [
            { no: 1, name: "tree_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "account_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<TreeAccount_Id>): TreeAccount_Id {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.treeId = 0;
        message.accountId = 0;
        if (value !== undefined)
            reflectionMergePartial<TreeAccount_Id>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TreeAccount_Id): TreeAccount_Id {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 tree_id */ 1:
                    message.treeId = reader.uint32();
                    break;
                case /* uint32 account_id */ 2:
                    message.accountId = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TreeAccount_Id, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 tree_id = 1; */
        if (message.treeId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.treeId);
        /* uint32 account_id = 2; */
        if (message.accountId !== 0)
            writer.tag(2, WireType.Varint).uint32(message.accountId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.TreeAccount.Id
 */
export const TreeAccount_Id = new TreeAccount_Id$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TreeAccount_List$Type extends MessageType<TreeAccount_List> {
    constructor() {
        super("mlmbox.types.TreeAccount.List", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => TreeAccount }
        ]);
    }
    create(value?: PartialMessage<TreeAccount_List>): TreeAccount_List {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial<TreeAccount_List>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TreeAccount_List): TreeAccount_List {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated mlmbox.types.TreeAccount items */ 1:
                    message.items.push(TreeAccount.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TreeAccount_List, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated mlmbox.types.TreeAccount items = 1; */
        for (let i = 0; i < message.items.length; i++)
            TreeAccount.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.TreeAccount.List
 */
export const TreeAccount_List = new TreeAccount_List$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TreeAccount_Entity$Type extends MessageType<TreeAccount_Entity> {
    constructor() {
        super("mlmbox.types.TreeAccount.Entity", [
            { no: 1, name: "position_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "tree_chain_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "tree_entity_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "tree_account_entity_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "filled_2w2l_bit_mask", kind: "scalar", jsonName: "filled2w2lBitMask", T: 13 /*ScalarType.UINT32*/ },
            { no: 6, name: "filled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "view_access", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<TreeAccount_Entity>): TreeAccount_Entity {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.positionId = 0;
        message.treeChainId = 0;
        message.treeEntityId = 0;
        message.treeAccountEntityId = 0;
        message.filled2W2LBitMask = 0;
        message.filled = false;
        message.viewAccess = false;
        if (value !== undefined)
            reflectionMergePartial<TreeAccount_Entity>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TreeAccount_Entity): TreeAccount_Entity {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 position_id */ 1:
                    message.positionId = reader.uint32();
                    break;
                case /* uint32 tree_chain_id */ 2:
                    message.treeChainId = reader.uint32();
                    break;
                case /* uint32 tree_entity_id */ 3:
                    message.treeEntityId = reader.uint32();
                    break;
                case /* uint32 tree_account_entity_id */ 4:
                    message.treeAccountEntityId = reader.uint32();
                    break;
                case /* uint32 filled_2w2l_bit_mask = 5 [json_name = "filled2w2lBitMask"];*/ 5:
                    message.filled2W2LBitMask = reader.uint32();
                    break;
                case /* bool filled */ 6:
                    message.filled = reader.bool();
                    break;
                case /* bool view_access */ 7:
                    message.viewAccess = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TreeAccount_Entity, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 position_id = 1; */
        if (message.positionId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.positionId);
        /* uint32 tree_chain_id = 2; */
        if (message.treeChainId !== 0)
            writer.tag(2, WireType.Varint).uint32(message.treeChainId);
        /* uint32 tree_entity_id = 3; */
        if (message.treeEntityId !== 0)
            writer.tag(3, WireType.Varint).uint32(message.treeEntityId);
        /* uint32 tree_account_entity_id = 4; */
        if (message.treeAccountEntityId !== 0)
            writer.tag(4, WireType.Varint).uint32(message.treeAccountEntityId);
        /* uint32 filled_2w2l_bit_mask = 5 [json_name = "filled2w2lBitMask"]; */
        if (message.filled2W2LBitMask !== 0)
            writer.tag(5, WireType.Varint).uint32(message.filled2W2LBitMask);
        /* bool filled = 6; */
        if (message.filled !== false)
            writer.tag(6, WireType.Varint).bool(message.filled);
        /* bool view_access = 7; */
        if (message.viewAccess !== false)
            writer.tag(7, WireType.Varint).bool(message.viewAccess);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.TreeAccount.Entity
 */
export const TreeAccount_Entity = new TreeAccount_Entity$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TreeAccount_Set$Type extends MessageType<TreeAccount_Set> {
    constructor() {
        super("mlmbox.types.TreeAccount.Set", [
            { no: 1, name: "tree_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "quantity", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "activated_quantity", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "activated_capacity", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "pool_value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "booking_quantity", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 7, name: "entity", kind: "message", T: () => TreeAccount_Entity }
        ]);
    }
    create(value?: PartialMessage<TreeAccount_Set>): TreeAccount_Set {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.treeId = 0;
        message.quantity = 0;
        message.activatedQuantity = 0;
        message.activatedCapacity = 0;
        message.poolValue = "";
        message.bookingQuantity = 0;
        if (value !== undefined)
            reflectionMergePartial<TreeAccount_Set>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TreeAccount_Set): TreeAccount_Set {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 tree_id */ 1:
                    message.treeId = reader.uint32();
                    break;
                case /* uint32 quantity */ 2:
                    message.quantity = reader.uint32();
                    break;
                case /* uint32 activated_quantity */ 3:
                    message.activatedQuantity = reader.uint32();
                    break;
                case /* uint32 activated_capacity */ 4:
                    message.activatedCapacity = reader.uint32();
                    break;
                case /* string pool_value */ 5:
                    message.poolValue = reader.string();
                    break;
                case /* uint32 booking_quantity */ 6:
                    message.bookingQuantity = reader.uint32();
                    break;
                case /* mlmbox.types.TreeAccount.Entity entity */ 7:
                    message.entity = TreeAccount_Entity.internalBinaryRead(reader, reader.uint32(), options, message.entity);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TreeAccount_Set, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 tree_id = 1; */
        if (message.treeId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.treeId);
        /* uint32 quantity = 2; */
        if (message.quantity !== 0)
            writer.tag(2, WireType.Varint).uint32(message.quantity);
        /* uint32 activated_quantity = 3; */
        if (message.activatedQuantity !== 0)
            writer.tag(3, WireType.Varint).uint32(message.activatedQuantity);
        /* uint32 activated_capacity = 4; */
        if (message.activatedCapacity !== 0)
            writer.tag(4, WireType.Varint).uint32(message.activatedCapacity);
        /* string pool_value = 5; */
        if (message.poolValue !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.poolValue);
        /* uint32 booking_quantity = 6; */
        if (message.bookingQuantity !== 0)
            writer.tag(6, WireType.Varint).uint32(message.bookingQuantity);
        /* mlmbox.types.TreeAccount.Entity entity = 7; */
        if (message.entity)
            TreeAccount_Entity.internalBinaryWrite(message.entity, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.TreeAccount.Set
 */
export const TreeAccount_Set = new TreeAccount_Set$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PositionView$Type extends MessageType<PositionView> {
    constructor() {
        super("mlmbox.types.PositionView", []);
    }
    create(value?: PartialMessage<PositionView>): PositionView {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<PositionView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PositionView): PositionView {
        return target ?? this.create();
    }
    internalBinaryWrite(message: PositionView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.PositionView
 */
export const PositionView = new PositionView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PositionView_Id$Type extends MessageType<PositionView_Id> {
    constructor() {
        super("mlmbox.types.PositionView.Id", [
            { no: 1, name: "view_position_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<PositionView_Id>): PositionView_Id {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.viewPositionId = 0;
        if (value !== undefined)
            reflectionMergePartial<PositionView_Id>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PositionView_Id): PositionView_Id {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 view_position_id */ 1:
                    message.viewPositionId = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PositionView_Id, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 view_position_id = 1; */
        if (message.viewPositionId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.viewPositionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.PositionView.Id
 */
export const PositionView_Id = new PositionView_Id$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PositionView_Team$Type extends MessageType<PositionView_Team> {
    constructor() {
        super("mlmbox.types.PositionView.Team", [
            { no: 1, name: "view_level", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "view_position_id", kind: "scalar", oneof: "query", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "tree_account_id", kind: "message", oneof: "query", T: () => TreeAccount_Id }
        ]);
    }
    create(value?: PartialMessage<PositionView_Team>): PositionView_Team {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.viewLevel = 0;
        message.query = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<PositionView_Team>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PositionView_Team): PositionView_Team {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 view_level */ 1:
                    message.viewLevel = reader.uint32();
                    break;
                case /* uint32 view_position_id */ 2:
                    message.query = {
                        oneofKind: "viewPositionId",
                        viewPositionId: reader.uint32()
                    };
                    break;
                case /* mlmbox.types.TreeAccount.Id tree_account_id */ 3:
                    message.query = {
                        oneofKind: "treeAccountId",
                        treeAccountId: TreeAccount_Id.internalBinaryRead(reader, reader.uint32(), options, (message.query as any).treeAccountId)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PositionView_Team, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 view_level = 1; */
        if (message.viewLevel !== 0)
            writer.tag(1, WireType.Varint).uint32(message.viewLevel);
        /* uint32 view_position_id = 2; */
        if (message.query.oneofKind === "viewPositionId")
            writer.tag(2, WireType.Varint).uint32(message.query.viewPositionId);
        /* mlmbox.types.TreeAccount.Id tree_account_id = 3; */
        if (message.query.oneofKind === "treeAccountId")
            TreeAccount_Id.internalBinaryWrite(message.query.treeAccountId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.PositionView.Team
 */
export const PositionView_Team = new PositionView_Team$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Matrix$Type extends MessageType<Matrix> {
    constructor() {
        super("mlmbox.types.Matrix", []);
    }
    create(value?: PartialMessage<Matrix>): Matrix {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Matrix>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Matrix): Matrix {
        return target ?? this.create();
    }
    internalBinaryWrite(message: Matrix, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Matrix
 */
export const Matrix = new Matrix$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Matrix_Reinvest$Type extends MessageType<Matrix_Reinvest> {
    constructor() {
        super("mlmbox.types.Matrix.Reinvest", []);
    }
    create(value?: PartialMessage<Matrix_Reinvest>): Matrix_Reinvest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Matrix_Reinvest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Matrix_Reinvest): Matrix_Reinvest {
        return target ?? this.create();
    }
    internalBinaryWrite(message: Matrix_Reinvest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Matrix.Reinvest
 */
export const Matrix_Reinvest = new Matrix_Reinvest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Matrix_Reinvest_Request$Type extends MessageType<Matrix_Reinvest_Request> {
    constructor() {
        super("mlmbox.types.Matrix.Reinvest.Request", [
            { no: 1, name: "position_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "reinvest_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<Matrix_Reinvest_Request>): Matrix_Reinvest_Request {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.positionId = 0;
        message.reinvestEnabled = false;
        if (value !== undefined)
            reflectionMergePartial<Matrix_Reinvest_Request>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Matrix_Reinvest_Request): Matrix_Reinvest_Request {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 position_id */ 1:
                    message.positionId = reader.uint32();
                    break;
                case /* bool reinvest_enabled */ 2:
                    message.reinvestEnabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Matrix_Reinvest_Request, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 position_id = 1; */
        if (message.positionId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.positionId);
        /* bool reinvest_enabled = 2; */
        if (message.reinvestEnabled !== false)
            writer.tag(2, WireType.Varint).bool(message.reinvestEnabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Matrix.Reinvest.Request
 */
export const Matrix_Reinvest_Request = new Matrix_Reinvest_Request$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Matrix_Position$Type extends MessageType<Matrix_Position> {
    constructor() {
        super("mlmbox.types.Matrix.Position", [
            { no: 1, name: "position_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "position_ref_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "position_ref_branch", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "position_width", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "account_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 6, name: "tree_chain_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 7, name: "tree_entity_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 8, name: "tree_account_entity_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 9, name: "partners_quantity", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 10, name: "team_quantity", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 11, name: "pool_value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "reinvest_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "filled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<Matrix_Position>): Matrix_Position {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.positionId = 0;
        message.positionRefId = 0;
        message.positionRefBranch = 0;
        message.positionWidth = 0;
        message.accountId = 0;
        message.treeChainId = 0;
        message.treeEntityId = 0;
        message.treeAccountEntityId = 0;
        message.partnersQuantity = 0;
        message.teamQuantity = 0;
        message.poolValue = "";
        message.reinvestEnabled = false;
        message.filled = false;
        if (value !== undefined)
            reflectionMergePartial<Matrix_Position>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Matrix_Position): Matrix_Position {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 position_id */ 1:
                    message.positionId = reader.uint32();
                    break;
                case /* uint32 position_ref_id */ 2:
                    message.positionRefId = reader.uint32();
                    break;
                case /* uint32 position_ref_branch */ 3:
                    message.positionRefBranch = reader.uint32();
                    break;
                case /* uint32 position_width */ 4:
                    message.positionWidth = reader.uint32();
                    break;
                case /* uint32 account_id */ 5:
                    message.accountId = reader.uint32();
                    break;
                case /* uint32 tree_chain_id */ 6:
                    message.treeChainId = reader.uint32();
                    break;
                case /* uint32 tree_entity_id */ 7:
                    message.treeEntityId = reader.uint32();
                    break;
                case /* uint32 tree_account_entity_id */ 8:
                    message.treeAccountEntityId = reader.uint32();
                    break;
                case /* uint32 partners_quantity */ 9:
                    message.partnersQuantity = reader.uint32();
                    break;
                case /* uint32 team_quantity */ 10:
                    message.teamQuantity = reader.uint32();
                    break;
                case /* string pool_value */ 11:
                    message.poolValue = reader.string();
                    break;
                case /* bool reinvest_enabled */ 12:
                    message.reinvestEnabled = reader.bool();
                    break;
                case /* bool filled */ 13:
                    message.filled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Matrix_Position, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 position_id = 1; */
        if (message.positionId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.positionId);
        /* uint32 position_ref_id = 2; */
        if (message.positionRefId !== 0)
            writer.tag(2, WireType.Varint).uint32(message.positionRefId);
        /* uint32 position_ref_branch = 3; */
        if (message.positionRefBranch !== 0)
            writer.tag(3, WireType.Varint).uint32(message.positionRefBranch);
        /* uint32 position_width = 4; */
        if (message.positionWidth !== 0)
            writer.tag(4, WireType.Varint).uint32(message.positionWidth);
        /* uint32 account_id = 5; */
        if (message.accountId !== 0)
            writer.tag(5, WireType.Varint).uint32(message.accountId);
        /* uint32 tree_chain_id = 6; */
        if (message.treeChainId !== 0)
            writer.tag(6, WireType.Varint).uint32(message.treeChainId);
        /* uint32 tree_entity_id = 7; */
        if (message.treeEntityId !== 0)
            writer.tag(7, WireType.Varint).uint32(message.treeEntityId);
        /* uint32 tree_account_entity_id = 8; */
        if (message.treeAccountEntityId !== 0)
            writer.tag(8, WireType.Varint).uint32(message.treeAccountEntityId);
        /* uint32 partners_quantity = 9; */
        if (message.partnersQuantity !== 0)
            writer.tag(9, WireType.Varint).uint32(message.partnersQuantity);
        /* uint32 team_quantity = 10; */
        if (message.teamQuantity !== 0)
            writer.tag(10, WireType.Varint).uint32(message.teamQuantity);
        /* string pool_value = 11; */
        if (message.poolValue !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.poolValue);
        /* bool reinvest_enabled = 12; */
        if (message.reinvestEnabled !== false)
            writer.tag(12, WireType.Varint).bool(message.reinvestEnabled);
        /* bool filled = 13; */
        if (message.filled !== false)
            writer.tag(13, WireType.Varint).bool(message.filled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Matrix.Position
 */
export const Matrix_Position = new Matrix_Position$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Matrix_View$Type extends MessageType<Matrix_View> {
    constructor() {
        super("mlmbox.types.Matrix.View", [
            { no: 1, name: "tree_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "self_position_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "self_tree_ids_bit_mask", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "view_position_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "view_tree_ids_bit_mask", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 6, name: "positions", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Matrix_Position },
            { no: 7, name: "accounts", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Account_Info },
            { no: 8, name: "view_tree_account_entities", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => TreeAccount_Entity }
        ]);
    }
    create(value?: PartialMessage<Matrix_View>): Matrix_View {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.treeId = 0;
        message.selfPositionId = 0;
        message.selfTreeIdsBitMask = 0;
        message.viewPositionId = 0;
        message.viewTreeIdsBitMask = 0;
        message.positions = [];
        message.accounts = [];
        message.viewTreeAccountEntities = [];
        if (value !== undefined)
            reflectionMergePartial<Matrix_View>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Matrix_View): Matrix_View {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 tree_id */ 1:
                    message.treeId = reader.uint32();
                    break;
                case /* uint32 self_position_id */ 2:
                    message.selfPositionId = reader.uint32();
                    break;
                case /* uint32 self_tree_ids_bit_mask */ 3:
                    message.selfTreeIdsBitMask = reader.uint32();
                    break;
                case /* uint32 view_position_id */ 4:
                    message.viewPositionId = reader.uint32();
                    break;
                case /* uint32 view_tree_ids_bit_mask */ 5:
                    message.viewTreeIdsBitMask = reader.uint32();
                    break;
                case /* repeated mlmbox.types.Matrix.Position positions */ 6:
                    message.positions.push(Matrix_Position.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated mlmbox.types.Account.Info accounts */ 7:
                    message.accounts.push(Account_Info.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated mlmbox.types.TreeAccount.Entity view_tree_account_entities */ 8:
                    message.viewTreeAccountEntities.push(TreeAccount_Entity.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Matrix_View, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 tree_id = 1; */
        if (message.treeId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.treeId);
        /* uint32 self_position_id = 2; */
        if (message.selfPositionId !== 0)
            writer.tag(2, WireType.Varint).uint32(message.selfPositionId);
        /* uint32 self_tree_ids_bit_mask = 3; */
        if (message.selfTreeIdsBitMask !== 0)
            writer.tag(3, WireType.Varint).uint32(message.selfTreeIdsBitMask);
        /* uint32 view_position_id = 4; */
        if (message.viewPositionId !== 0)
            writer.tag(4, WireType.Varint).uint32(message.viewPositionId);
        /* uint32 view_tree_ids_bit_mask = 5; */
        if (message.viewTreeIdsBitMask !== 0)
            writer.tag(5, WireType.Varint).uint32(message.viewTreeIdsBitMask);
        /* repeated mlmbox.types.Matrix.Position positions = 6; */
        for (let i = 0; i < message.positions.length; i++)
            Matrix_Position.internalBinaryWrite(message.positions[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated mlmbox.types.Account.Info accounts = 7; */
        for (let i = 0; i < message.accounts.length; i++)
            Account_Info.internalBinaryWrite(message.accounts[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated mlmbox.types.TreeAccount.Entity view_tree_account_entities = 8; */
        for (let i = 0; i < message.viewTreeAccountEntities.length; i++)
            TreeAccount_Entity.internalBinaryWrite(message.viewTreeAccountEntities[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Matrix.View
 */
export const Matrix_View = new Matrix_View$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Matrix_Info$Type extends MessageType<Matrix_Info> {
    constructor() {
        super("mlmbox.types.Matrix.Info", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => TreeAccount }
        ]);
    }
    create(value?: PartialMessage<Matrix_Info>): Matrix_Info {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial<Matrix_Info>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Matrix_Info): Matrix_Info {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated mlmbox.types.TreeAccount items */ 1:
                    message.items.push(TreeAccount.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Matrix_Info, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated mlmbox.types.TreeAccount items = 1; */
        for (let i = 0; i < message.items.length; i++)
            TreeAccount.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Matrix.Info
 */
export const Matrix_Info = new Matrix_Info$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Binary$Type extends MessageType<Binary> {
    constructor() {
        super("mlmbox.types.Binary", []);
    }
    create(value?: PartialMessage<Binary>): Binary {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Binary>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Binary): Binary {
        return target ?? this.create();
    }
    internalBinaryWrite(message: Binary, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Binary
 */
export const Binary = new Binary$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Binary_BranchSelectStrategy$Type extends MessageType<Binary_BranchSelectStrategy> {
    constructor() {
        super("mlmbox.types.Binary.BranchSelectStrategy", [
            { no: 1, name: "branch_select_strategy_id", kind: "enum", T: () => ["mlmbox.types.Binary.BranchSelectStrategy.Id", Binary_BranchSelectStrategy_Id] }
        ]);
    }
    create(value?: PartialMessage<Binary_BranchSelectStrategy>): Binary_BranchSelectStrategy {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.branchSelectStrategyId = 0;
        if (value !== undefined)
            reflectionMergePartial<Binary_BranchSelectStrategy>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Binary_BranchSelectStrategy): Binary_BranchSelectStrategy {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* mlmbox.types.Binary.BranchSelectStrategy.Id branch_select_strategy_id */ 1:
                    message.branchSelectStrategyId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Binary_BranchSelectStrategy, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* mlmbox.types.Binary.BranchSelectStrategy.Id branch_select_strategy_id = 1; */
        if (message.branchSelectStrategyId !== 0)
            writer.tag(1, WireType.Varint).int32(message.branchSelectStrategyId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Binary.BranchSelectStrategy
 */
export const Binary_BranchSelectStrategy = new Binary_BranchSelectStrategy$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Binary_BranchSelectStrategy_Request$Type extends MessageType<Binary_BranchSelectStrategy_Request> {
    constructor() {
        super("mlmbox.types.Binary.BranchSelectStrategy.Request", [
            { no: 1, name: "position_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "branch_select_strategy_id", kind: "enum", T: () => ["mlmbox.types.Binary.BranchSelectStrategy.Id", Binary_BranchSelectStrategy_Id] }
        ]);
    }
    create(value?: PartialMessage<Binary_BranchSelectStrategy_Request>): Binary_BranchSelectStrategy_Request {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.positionId = 0;
        message.branchSelectStrategyId = 0;
        if (value !== undefined)
            reflectionMergePartial<Binary_BranchSelectStrategy_Request>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Binary_BranchSelectStrategy_Request): Binary_BranchSelectStrategy_Request {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 position_id */ 1:
                    message.positionId = reader.uint32();
                    break;
                case /* mlmbox.types.Binary.BranchSelectStrategy.Id branch_select_strategy_id */ 2:
                    message.branchSelectStrategyId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Binary_BranchSelectStrategy_Request, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 position_id = 1; */
        if (message.positionId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.positionId);
        /* mlmbox.types.Binary.BranchSelectStrategy.Id branch_select_strategy_id = 2; */
        if (message.branchSelectStrategyId !== 0)
            writer.tag(2, WireType.Varint).int32(message.branchSelectStrategyId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Binary.BranchSelectStrategy.Request
 */
export const Binary_BranchSelectStrategy_Request = new Binary_BranchSelectStrategy_Request$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Binary_Config$Type extends MessageType<Binary_Config> {
    constructor() {
        super("mlmbox.types.Binary.Config", [
            { no: 1, name: "bonus_binary_percent", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "bonus_matching_percent", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "tree_entities_quantity", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<Binary_Config>): Binary_Config {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bonusBinaryPercent = "";
        message.bonusMatchingPercent = "";
        message.treeEntitiesQuantity = 0;
        if (value !== undefined)
            reflectionMergePartial<Binary_Config>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Binary_Config): Binary_Config {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string bonus_binary_percent */ 1:
                    message.bonusBinaryPercent = reader.string();
                    break;
                case /* string bonus_matching_percent */ 2:
                    message.bonusMatchingPercent = reader.string();
                    break;
                case /* uint32 tree_entities_quantity */ 3:
                    message.treeEntitiesQuantity = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Binary_Config, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string bonus_binary_percent = 1; */
        if (message.bonusBinaryPercent !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.bonusBinaryPercent);
        /* string bonus_matching_percent = 2; */
        if (message.bonusMatchingPercent !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.bonusMatchingPercent);
        /* uint32 tree_entities_quantity = 3; */
        if (message.treeEntitiesQuantity !== 0)
            writer.tag(3, WireType.Varint).uint32(message.treeEntitiesQuantity);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Binary.Config
 */
export const Binary_Config = new Binary_Config$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Binary_Position$Type extends MessageType<Binary_Position> {
    constructor() {
        super("mlmbox.types.Binary.Position", [
            { no: 1, name: "position_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "position_ref_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "position_ref_branch", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "position_width", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "account_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 6, name: "tree_chain_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 7, name: "tree_entity_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 8, name: "tree_account_entity_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 9, name: "partners_quantity", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 10, name: "team_quantity", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 11, name: "earned_value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "branch_select_strategy", kind: "enum", T: () => ["mlmbox.types.Binary.BranchSelectStrategy.Id", Binary_BranchSelectStrategy_Id] },
            { no: 13, name: "branch_left", kind: "message", T: () => Binary_Position_Branch },
            { no: 14, name: "branch_right", kind: "message", T: () => Binary_Position_Branch }
        ]);
    }
    create(value?: PartialMessage<Binary_Position>): Binary_Position {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.positionId = 0;
        message.positionRefId = 0;
        message.positionRefBranch = 0;
        message.positionWidth = 0;
        message.accountId = 0;
        message.treeChainId = 0;
        message.treeEntityId = 0;
        message.treeAccountEntityId = 0;
        message.partnersQuantity = 0;
        message.teamQuantity = 0;
        message.earnedValue = "";
        message.branchSelectStrategy = 0;
        if (value !== undefined)
            reflectionMergePartial<Binary_Position>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Binary_Position): Binary_Position {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 position_id */ 1:
                    message.positionId = reader.uint32();
                    break;
                case /* uint32 position_ref_id */ 2:
                    message.positionRefId = reader.uint32();
                    break;
                case /* uint32 position_ref_branch */ 3:
                    message.positionRefBranch = reader.uint32();
                    break;
                case /* uint32 position_width */ 4:
                    message.positionWidth = reader.uint32();
                    break;
                case /* uint32 account_id */ 5:
                    message.accountId = reader.uint32();
                    break;
                case /* uint32 tree_chain_id */ 6:
                    message.treeChainId = reader.uint32();
                    break;
                case /* uint32 tree_entity_id */ 7:
                    message.treeEntityId = reader.uint32();
                    break;
                case /* uint32 tree_account_entity_id */ 8:
                    message.treeAccountEntityId = reader.uint32();
                    break;
                case /* uint32 partners_quantity */ 9:
                    message.partnersQuantity = reader.uint32();
                    break;
                case /* uint32 team_quantity */ 10:
                    message.teamQuantity = reader.uint32();
                    break;
                case /* string earned_value */ 11:
                    message.earnedValue = reader.string();
                    break;
                case /* mlmbox.types.Binary.BranchSelectStrategy.Id branch_select_strategy */ 12:
                    message.branchSelectStrategy = reader.int32();
                    break;
                case /* mlmbox.types.Binary.Position.Branch branch_left */ 13:
                    message.branchLeft = Binary_Position_Branch.internalBinaryRead(reader, reader.uint32(), options, message.branchLeft);
                    break;
                case /* mlmbox.types.Binary.Position.Branch branch_right */ 14:
                    message.branchRight = Binary_Position_Branch.internalBinaryRead(reader, reader.uint32(), options, message.branchRight);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Binary_Position, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 position_id = 1; */
        if (message.positionId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.positionId);
        /* uint32 position_ref_id = 2; */
        if (message.positionRefId !== 0)
            writer.tag(2, WireType.Varint).uint32(message.positionRefId);
        /* uint32 position_ref_branch = 3; */
        if (message.positionRefBranch !== 0)
            writer.tag(3, WireType.Varint).uint32(message.positionRefBranch);
        /* uint32 position_width = 4; */
        if (message.positionWidth !== 0)
            writer.tag(4, WireType.Varint).uint32(message.positionWidth);
        /* uint32 account_id = 5; */
        if (message.accountId !== 0)
            writer.tag(5, WireType.Varint).uint32(message.accountId);
        /* uint32 tree_chain_id = 6; */
        if (message.treeChainId !== 0)
            writer.tag(6, WireType.Varint).uint32(message.treeChainId);
        /* uint32 tree_entity_id = 7; */
        if (message.treeEntityId !== 0)
            writer.tag(7, WireType.Varint).uint32(message.treeEntityId);
        /* uint32 tree_account_entity_id = 8; */
        if (message.treeAccountEntityId !== 0)
            writer.tag(8, WireType.Varint).uint32(message.treeAccountEntityId);
        /* uint32 partners_quantity = 9; */
        if (message.partnersQuantity !== 0)
            writer.tag(9, WireType.Varint).uint32(message.partnersQuantity);
        /* uint32 team_quantity = 10; */
        if (message.teamQuantity !== 0)
            writer.tag(10, WireType.Varint).uint32(message.teamQuantity);
        /* string earned_value = 11; */
        if (message.earnedValue !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.earnedValue);
        /* mlmbox.types.Binary.BranchSelectStrategy.Id branch_select_strategy = 12; */
        if (message.branchSelectStrategy !== 0)
            writer.tag(12, WireType.Varint).int32(message.branchSelectStrategy);
        /* mlmbox.types.Binary.Position.Branch branch_left = 13; */
        if (message.branchLeft)
            Binary_Position_Branch.internalBinaryWrite(message.branchLeft, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* mlmbox.types.Binary.Position.Branch branch_right = 14; */
        if (message.branchRight)
            Binary_Position_Branch.internalBinaryWrite(message.branchRight, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Binary.Position
 */
export const Binary_Position = new Binary_Position$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Binary_Position_Branch$Type extends MessageType<Binary_Position_Branch> {
    constructor() {
        super("mlmbox.types.Binary.Position.Branch", [
            { no: 1, name: "team_quantity", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "balance_value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "turnover_value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Binary_Position_Branch>): Binary_Position_Branch {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.teamQuantity = 0;
        message.balanceValue = "";
        message.turnoverValue = "";
        if (value !== undefined)
            reflectionMergePartial<Binary_Position_Branch>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Binary_Position_Branch): Binary_Position_Branch {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 team_quantity */ 1:
                    message.teamQuantity = reader.uint32();
                    break;
                case /* string balance_value */ 2:
                    message.balanceValue = reader.string();
                    break;
                case /* string turnover_value */ 3:
                    message.turnoverValue = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Binary_Position_Branch, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 team_quantity = 1; */
        if (message.teamQuantity !== 0)
            writer.tag(1, WireType.Varint).uint32(message.teamQuantity);
        /* string balance_value = 2; */
        if (message.balanceValue !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.balanceValue);
        /* string turnover_value = 3; */
        if (message.turnoverValue !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.turnoverValue);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Binary.Position.Branch
 */
export const Binary_Position_Branch = new Binary_Position_Branch$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Binary_View$Type extends MessageType<Binary_View> {
    constructor() {
        super("mlmbox.types.Binary.View", [
            { no: 1, name: "tree_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "config", kind: "message", T: () => Binary_Config },
            { no: 3, name: "self_position_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "self_tree_ids_bit_mask", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "view_position_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 6, name: "view_tree_ids_bit_mask", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 7, name: "positions", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Binary_Position },
            { no: 8, name: "accounts", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Account_Info },
            { no: 9, name: "view_tree_account_entities", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => TreeAccount_Entity }
        ]);
    }
    create(value?: PartialMessage<Binary_View>): Binary_View {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.treeId = 0;
        message.selfPositionId = 0;
        message.selfTreeIdsBitMask = 0;
        message.viewPositionId = 0;
        message.viewTreeIdsBitMask = 0;
        message.positions = [];
        message.accounts = [];
        message.viewTreeAccountEntities = [];
        if (value !== undefined)
            reflectionMergePartial<Binary_View>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Binary_View): Binary_View {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 tree_id */ 1:
                    message.treeId = reader.uint32();
                    break;
                case /* mlmbox.types.Binary.Config config */ 2:
                    message.config = Binary_Config.internalBinaryRead(reader, reader.uint32(), options, message.config);
                    break;
                case /* uint32 self_position_id */ 3:
                    message.selfPositionId = reader.uint32();
                    break;
                case /* uint32 self_tree_ids_bit_mask */ 4:
                    message.selfTreeIdsBitMask = reader.uint32();
                    break;
                case /* uint32 view_position_id */ 5:
                    message.viewPositionId = reader.uint32();
                    break;
                case /* uint32 view_tree_ids_bit_mask */ 6:
                    message.viewTreeIdsBitMask = reader.uint32();
                    break;
                case /* repeated mlmbox.types.Binary.Position positions */ 7:
                    message.positions.push(Binary_Position.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated mlmbox.types.Account.Info accounts */ 8:
                    message.accounts.push(Account_Info.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated mlmbox.types.TreeAccount.Entity view_tree_account_entities */ 9:
                    message.viewTreeAccountEntities.push(TreeAccount_Entity.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Binary_View, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 tree_id = 1; */
        if (message.treeId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.treeId);
        /* mlmbox.types.Binary.Config config = 2; */
        if (message.config)
            Binary_Config.internalBinaryWrite(message.config, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* uint32 self_position_id = 3; */
        if (message.selfPositionId !== 0)
            writer.tag(3, WireType.Varint).uint32(message.selfPositionId);
        /* uint32 self_tree_ids_bit_mask = 4; */
        if (message.selfTreeIdsBitMask !== 0)
            writer.tag(4, WireType.Varint).uint32(message.selfTreeIdsBitMask);
        /* uint32 view_position_id = 5; */
        if (message.viewPositionId !== 0)
            writer.tag(5, WireType.Varint).uint32(message.viewPositionId);
        /* uint32 view_tree_ids_bit_mask = 6; */
        if (message.viewTreeIdsBitMask !== 0)
            writer.tag(6, WireType.Varint).uint32(message.viewTreeIdsBitMask);
        /* repeated mlmbox.types.Binary.Position positions = 7; */
        for (let i = 0; i < message.positions.length; i++)
            Binary_Position.internalBinaryWrite(message.positions[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated mlmbox.types.Account.Info accounts = 8; */
        for (let i = 0; i < message.accounts.length; i++)
            Account_Info.internalBinaryWrite(message.accounts[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated mlmbox.types.TreeAccount.Entity view_tree_account_entities = 9; */
        for (let i = 0; i < message.viewTreeAccountEntities.length; i++)
            TreeAccount_Entity.internalBinaryWrite(message.viewTreeAccountEntities[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Binary.View
 */
export const Binary_View = new Binary_View$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Binary_Info$Type extends MessageType<Binary_Info> {
    constructor() {
        super("mlmbox.types.Binary.Info", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Binary_Info_Item }
        ]);
    }
    create(value?: PartialMessage<Binary_Info>): Binary_Info {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial<Binary_Info>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Binary_Info): Binary_Info {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated mlmbox.types.Binary.Info.Item items */ 1:
                    message.items.push(Binary_Info_Item.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Binary_Info, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated mlmbox.types.Binary.Info.Item items = 1; */
        for (let i = 0; i < message.items.length; i++)
            Binary_Info_Item.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Binary.Info
 */
export const Binary_Info = new Binary_Info$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Binary_Info_Item$Type extends MessageType<Binary_Info_Item> {
    constructor() {
        super("mlmbox.types.Binary.Info.Item", [
            { no: 1, name: "tree_account", kind: "message", T: () => TreeAccount },
            { no: 2, name: "config", kind: "message", T: () => Binary_Config }
        ]);
    }
    create(value?: PartialMessage<Binary_Info_Item>): Binary_Info_Item {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Binary_Info_Item>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Binary_Info_Item): Binary_Info_Item {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* mlmbox.types.TreeAccount tree_account */ 1:
                    message.treeAccount = TreeAccount.internalBinaryRead(reader, reader.uint32(), options, message.treeAccount);
                    break;
                case /* mlmbox.types.Binary.Config config */ 2:
                    message.config = Binary_Config.internalBinaryRead(reader, reader.uint32(), options, message.config);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Binary_Info_Item, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* mlmbox.types.TreeAccount tree_account = 1; */
        if (message.treeAccount)
            TreeAccount.internalBinaryWrite(message.treeAccount, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* mlmbox.types.Binary.Config config = 2; */
        if (message.config)
            Binary_Config.internalBinaryWrite(message.config, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Binary.Info.Item
 */
export const Binary_Info_Item = new Binary_Info_Item$Type();
